import { render, staticRenderFns } from "./AllInfo.vue?vue&type=template&id=0b3c1b3a&"
import script from "./AllInfo.vue?vue&type=script&lang=js&"
export * from "./AllInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports